function isMobile() {
  return window.innerWidth < 1024;
}

function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}
if (isTouchDevice()) {
  document.body.classList.add('is-touch-device');
}

Shopify.getCart = async function () {
  const response = await fetch(Shopify.routes.root + 'cart.js');
  const data = await response.json();
  return data;
};

Shopify.addToCart = async function (variants, options = {}) {
  const { eventData = {} } = options;
  const cartDrawer = document.querySelector('cart-drawer');

  if (typeof variants === 'string') {
    variants = [{ id: variants }];
  }
  const response = await fetch(Shopify.routes.root + 'cart/add.js', {
    ...fetchConfig(),
    body: JSON.stringify({
      items: variants,
      sections: cartDrawer?.getSectionsToRender().map((section) => section.id) || [],
      sections_url: window.location.pathname,
    }),
  });
  if (response.status) {
  }
  const data = await response.json();

  if (cartDrawer) {
    // Don't open drawer automatically, just update contents
    cartDrawer.renderContents(data, false);
  }

  // Always show add to cart banner
  const banner = document.getElementById('add-to-cart-banner');
  if (banner && banner.show && data.items && data.items.length > 0) {
    // Handle multiple items (swatches)
    const itemCount = data.items.length;
    const productName = itemCount === 1
      ? data.items[0].product_title
      : `${itemCount} Swatches`;
    banner.show(productName);
  }

  publish(PUB_SUB_EVENTS.cartUpdate, {
    source: 'shopify',
    productVariantId: variants,
    ...eventData,
  });

  return data;
};

Shopify.formatMoney = function (cents, format = '${{amount}}') {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  const value = parseInt(cents) / 100;
  const formatWithCurrency = format || window.theme.moneyFormat;

  if (window.themeSettings.removeCents) {
    return formatWithCurrency.replace('{{amount}}', value.toFixed(0));
  } else {
    return formatWithCurrency.replace('{{amount}}', value);
  }
};

function getFocusableElements(container) {
  if (!container) return [];
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function trackOptionSelected(name, value) {
  const optionData = {
    option_name: name,
    option_value: value,
  };
  // console.log('product_option_selected', optionData);
  Shopify.analytics.publish('product_option_selected', optionData);
}

class HTMLUpdateUtility {
  #preProcessCallbacks = [];
  #postProcessCallbacks = [];

  constructor() {}

  addPreProcessCallback(callback) {
    this.#preProcessCallbacks.push(callback);
  }

  addPostProcessCallback(callback) {
    this.#postProcessCallbacks.push(callback);
  }

  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  viewTransition(oldNode, newContent) {
    this.#preProcessCallbacks.forEach((callback) => callback(newContent));

    const newNode = oldNode.cloneNode();
    HTMLUpdateUtility.setInnerHTML(newNode, newContent.innerHTML);
    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    this.#postProcessCallbacks.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 1000);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

// `focusVisible` defaults to false so existing callers keep suppressing the focus
// ring on mouse-driven opens. Pass true when focus is moved as the result of a
// keyboard action, so the user can see where focus landed (WCAG 2.4.7).
function trapFocus(container, elementToFocus = container, { focusVisible = false } = {}) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    // Wrapping inside the trap only ever happens on TAB, so the ring always shows.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus({ focusVisible: true });
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus({ focusVisible: true });
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus({ focusVisible });

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus({ focusVisible: false });
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus({ focusVisible: false });
}

// Hide header on scroll down and show on scroll up when .header-wrapper--hide-on-scroll is present
document.querySelectorAll('.header-wrapper--hide-on-scroll').forEach((header) => {
  let lastScrollTop = 0;
  let currentScrollTop = 0;
  let scrollDirection = 'down';
  let scrollThreshold = 100;
  let scrollOffset = 0;
  let headerHeight = header.clientHeight + 4;
  const showOnScrollUp = header.classList.contains('header-wrapper--show-on-scroll-up');

  window.addEventListener('scroll', () => {
    currentScrollTop = window.scrollY;
    scrollDirection = currentScrollTop > lastScrollTop ? 'down' : 'up';

    if (Math.abs(currentScrollTop - lastScrollTop) < scrollThreshold) return;

    if (scrollDirection === 'down' && currentScrollTop > scrollOffset) {
      header.parentElement.style.transform = `translateY(-${headerHeight}px)`;
      // document.querySelector('.section-header').classList.add('header-hidden');
    } else if (scrollDirection === 'up' && currentScrollTop > scrollThreshold) {
      if (showOnScrollUp) {
        header.parentElement.style.transform = 'translateY(0)';
      }
    } else {
      header.parentElement.style.transform = 'translateY(0)';
    }

    lastScrollTop = currentScrollTop;
  });
});

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      const cartItem = this.closest('.new-cart-item');
      // Only show remove confirmation for cart items, not for additional-items
      if (cartItem && this.input.value == 1 && !cartItem.classList.contains('show-remove-confirmation')) {
        cartItem.classList.add('show-remove-confirmation');
        const removeButtons = cartItem.querySelector(".new-cart-item__remove-buttons");
        if (removeButtons) {
          setTimeout(() => {
            const removeButtonsRect = removeButtons.getBoundingClientRect();
            const cartDrawerItems = this.closest("cart-drawer-items");
            const cartDrawerItemsRect = cartDrawerItems.getBoundingClientRect();

            // Check if remove buttons are outside viewport by at least 10px
            const isAboveViewport = removeButtonsRect.bottom < (cartDrawerItemsRect.top + 10);
            const isBelowViewport = removeButtonsRect.top > (cartDrawerItemsRect.bottom - 10);

            if (isAboveViewport || isBelowViewport) {
              const scrollTop = cartDrawerItems.scrollTop;
              let newScrollTop;

              if (isAboveViewport) {
                // Scroll up just enough to show the top of the remove buttons with 20px padding
                newScrollTop = scrollTop + (removeButtonsRect.top - cartDrawerItemsRect.top - 20);
              } else {
                // Scroll down just enough to show the bottom of the remove buttons with 20px padding
                newScrollTop = scrollTop + (removeButtonsRect.bottom - cartDrawerItemsRect.bottom + 20);
              }

              cartDrawerItems.scrollTo({ top: newScrollTop, behavior: 'smooth' });
            }
          }, 200)
        }
        // cartItem.closest('.drawer__inner').scrollTo({ top: cartItem.offsetTop - 85, behavior: 'smooth' });
        return;
      } else {
        this.input.stepDown();
      }
    }

    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }

  setQuantity(value) {
    this.input.value = value;
    this.input.dispatchEvent(this.changeEvent);
    this.validateQtyRules();
  }

  getQuantity() {
    return this.input.value;
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );

    this.querySelectorAll('[data-close-menu]').forEach((button) => {
      button.addEventListener('click', (e) => {
        const closestDetails = button.closest('details');
        this.closeSubmenu(closestDetails);
        this.closeMenuDrawer(e, button);
      });
    });

    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button):not([data-close-menu]):not(.mobile-facets__clear-all):not(.facets-filter-search__clear-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));

    this.closeOnClickOutside();
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 1023px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details.menu-item__top-level').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    // console.log(detailsElement)
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    // Get the computed styles and check for the animation duration CSS variable
    const computedStyles = window.getComputedStyle(detailsElement);
    const cssAnimationDuration = computedStyles.getPropertyValue('--animation-duration');
    // Convert CSS time value (e.g. "1s" or "1000ms") to milliseconds, fallback to 300ms
    const getDurationInMs = (cssValue) => {
      if (!cssValue) return 300;
      const value = parseFloat(cssValue);
      return cssValue.includes('ms') ? value : value * 1000;
    };
    const animationDuration = getDurationInMs(cssAnimationDuration);

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < animationDuration) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }

  closeOnClickOutside() {
    document.addEventListener('click', (event) => {
      // Check if a mobile facets drawer is open
      const openDrawer = document.querySelector('details.mobile-facets__disclosure[open]');
      if (!openDrawer) return;

      // Check if click is outside .mobile-facets__inner
      const inner = event.target.closest('.mobile-facets__inner');
      if (!inner) {
        // Find the summary element to click and close the drawer
        const summary = openDrawer.querySelector('summary');
        if (summary) {
          summary.click();
        }
      }
    });
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);


// class Modal extends HTMLElement {
//   constructor() {
//     super();
//   }
  
//   close() {
//     document.querySelectorAll('.modal--visible').forEach((modal) => {
//       modal.classList.remove('modal--visible');
//       modal.setAttribute('aria-hidden', 'true');
//     });

//     this.setAttribute('aria-hidden', 'false');
//     this.classList.add('modal--visible');
//   }
// }

// customElements.define('modal-dialog', ModalDialog);
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus({ focusVisible: false });
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = this.dataset.looping || false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    if (this.prevButton || this.nextButton) this.setButtonSteps();
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    // console.log(this.sliderItemOffset, event.currentTarget.dataset.step);
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset === this.sliderItems.length * this.sliderItemOffset
          ? 0
          : this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft === 0
        ? this.sliderItemOffset * this.sliderItems.length
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setButtonSteps() {
    // Set the step to the number of slides that are visible in the slider
    this.nextButton.dataset.step = this.slidesPerPage > 0 ? this.slidesPerPage : 1;
    this.prevButton.dataset.step = this.slidesPerPage > 0 ? this.slidesPerPage : 1;
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.handleProductUpdate);
    this.initializeProductSwapUtility();
    this.hoveredScrollPosition = null;
    this.setupHoverListeners();
    this.parentSection = this.closest('.shopify-section');
  }

  setupHoverListeners() {
    // Add hover listeners to all product option elements
    const optionElements = this.querySelectorAll('input[type="radio"], select, .swatch-item, .product-option');
    optionElements.forEach(element => {
      element.addEventListener('mouseenter', () => {
        this.hoveredScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      });
    });
  }

  initializeProductSwapUtility() {
    this.swapProductUtility = new HTMLUpdateUtility();
    this.swapProductUtility.addPreProcessCallback((html) => {
      html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'));
      return html;
    });
    this.swapProductUtility.addPostProcessCallback((newNode) => {
      window?.Shopify?.PaymentButton?.init();
      window?.ProductModel?.loadShopifyXR();
      publish(PUB_SUB_EVENTS.sectionRefreshed, {
        data: {
          sectionId: this.dataset.section,
          resource: {
            type: SECTION_REFRESH_RESOURCE_TYPE.product,
            id: newNode.querySelector('variant-selects').dataset.productId,
          },
        },
      });
    });
  }

  handleProductUpdate(event) {
    const currentScrollPosition = window.pageYOffset;
    const input = this.getInputForEventTarget(event.target);
    const targetId = input.id;
    const targetUrl = input.dataset.productUrl;
    this.currentVariant = this.getVariantData(targetId);

    this.parentSection.classList.add('product--updating');
    
    // Store and restore scroll position when variant changes
    if (this.currentVariant) {
      // Check if any upholstery accordion is open and has more than 15 small swatches
      const upholsteryAccordions = document.querySelectorAll('animated-accordion-mobile-slideover#upholstery');
      const hasOpenUpholstery = Array.from(upholsteryAccordions).some(accordion => {
        const details = accordion.querySelector('details');
        return details?.open;
      });
      const smallSwatches = document.querySelectorAll('.small-swatch');
      
      if (hasOpenUpholstery && smallSwatches.length > 15) {
        // Use the position from when the option was hovered, or fall back to current position
        const scrollPosition = this.hoveredScrollPosition !== null ? this.hoveredScrollPosition : (window.pageYOffset || document.documentElement.scrollTop);
        
        // Repeatedly restore scroll position every 10ms for 750ms
        let elapsed = 0;
        const interval = setInterval(() => {
          window.scrollTo({
            top: scrollPosition,
            left: 0,
            behavior: 'instant'
          });
          
          elapsed += 10;
          if (elapsed >= 750) {
            clearInterval(interval);
          }
        }, 10);
      }
    }
    
    if (this.currentVariant === null && input.getAttribute('data-first-available-id')) {
      // this.currentVariant = { id: input.getAttribute('data-first-available-id') };
    }
    const sectionId = this.dataset.originalSection || this.dataset.section;
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.removeErrorMessage();

    let callback = () => {};
    if (this.dataset.url !== targetUrl) {
      this.updateURL(targetUrl);
      this.updateShareUrl(targetUrl);
      callback = this.handleSwapProduct(sectionId);
    } else if (!this.currentVariant) {
      this.setUnavailable();
      callback = (html) => {
        this.updatePickupAvailability();
        this.updateOptionValues(html);
      };
    } else {
      this.updateURL(targetUrl);
      this.updateVariantInput();
      this.updateShareUrl(targetUrl);
      callback = this.handleUpdateProductInfo(sectionId);
    }

    // Fire the fetch immediately; gate the DOM reveal by minimum fade time
    const startTime = performance.now();
    const parentSection = this.parentSection;
    this.renderProductInfo(sectionId, targetUrl, targetId, (html) => {
      const elapsed = performance.now() - startTime;
      const minFadeTime = 350;
      const remaining = Math.max(0, minFadeTime - elapsed);
      setTimeout(() => {
        callback(html);
        parentSection.classList.remove('product--updating');
      }, remaining);
    });
  }

  getSelectedOptionValues() {
    // return Array.from(this.querySelectorAll('select, fieldset input:checked')).map(
    //   (element) => element.dataset.optionValueId
    // );

    // Options need to be manually sorted into Shopify's expected order for the option_values parameter to work
    const optionsOrder = this.dataset?.options?.split(',,') || [];

    let fieldsets = Array.from(this.querySelectorAll('fieldset'));
    // sort fieldsets by options order. the option name inside fieldset is obtained by querying 'input' and getting its name attribute
    fieldsets = fieldsets.sort((a, b) => {
      const aName = a.querySelector('input').name?.trim()?.split('-')[0];
      const bName = b.querySelector('input').name?.trim()?.split('-')[0];
      return optionsOrder.indexOf(aName) - optionsOrder.indexOf(bName);
    });

    const selected = [];
    fieldsets.forEach((fieldset) => {
      // pick checked input, if not first input
      const checkedInput = fieldset.querySelector('input:checked');
      if (checkedInput) {
        selected.push(checkedInput.dataset.optionValueId);
        return;
      }

      // pick first input
      const firstInput = fieldset.querySelector('input');
      if (firstInput) selected.push(firstInput.dataset.optionValueId);
    });

    return selected;
  }

  updateSelectedSwatchValue({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }

    trackOptionSelected(target.name.split('-')[0], target.value);
  }

  updateMedia(html) {
    const mediaGallerySource = document.querySelector(`[id^="MediaGallery-${this.dataset.section}"] ul`);
    const mediaGalleryDestination = html.querySelector(`[id^="MediaGallery-${this.dataset.section}"] ul`);

    const refreshSourceData = () => {
      const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
      const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
      const sourceMap = new Map(mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }]));
      return [mediaGallerySourceItems, sourceSet, sourceMap];
    };

    if (mediaGallerySource && mediaGalleryDestination) {
      let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
      const mediaGalleryDestinationItems = Array.from(mediaGalleryDestination.querySelectorAll('li[data-media-id]'));
      const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
      let shouldRefresh = false;

      // add items from new data not present in DOM
      for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
        if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
          mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
          shouldRefresh = true;
        }
      }

      // remove items from DOM not present in new data
      for (let i = 0; i < mediaGallerySourceItems.length; i++) {
        if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
          mediaGallerySourceItems[i].remove();
          shouldRefresh = true;
        }
      }

      // refresh
      if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

      // if media galleries don't match, sort to match new data order
      mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
        const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

        if (sourceData && sourceData.index !== destinationIndex) {
          mediaGallerySource.insertBefore(
            sourceData.item,
            mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
          );

          // refresh source now that it has been modified
          [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
        }
      });
    }

    document
      .querySelector(`[id^="MediaGallery-${this.dataset.section}"]`)
      .setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media?.id}`);

    // update media modal
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newModalContent = html.querySelector(`product-modal`);
    if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
  }

  updateURL(url) {
    if (this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${url}${this.currentVariant?.id ? `?variant=${this.currentVariant.id}` : ''}`);
  }

  updateShareUrl(url) {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${url}${this.currentVariant?.id ? `?variant=${this.currentVariant.id}` : ''}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  getVariantData(inputId) {
    return JSON.parse(this.getVariantDataElement(inputId).textContent);
  }

  getVariantDataElement(inputId) {
    return this.querySelector(`script[type="application/json"][data-resource="${inputId}"]`);
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  getWrappingSection(sectionId) {
    return (
      this.closest(`section[data-section="${sectionId}"]`) || // main-product
      this.closest(`quick-add-modal`)?.modalContent || // quick-add
      this.closest(`#shopify-section-${sectionId}`) || // featured-product
      null
    );
  }

  handleSwapProduct(sectionId) {
    return (html) => {
      const oldContent = this.getWrappingSection(sectionId);
      if (!oldContent) {
        return;
      }

      document.getElementById(`ProductModal-${sectionId}`)?.remove();
      ProductInfoState.renderRestoredSection(html);
      ProductUtils.setLoading(false);

      // const response =
      //   html.querySelector(`section[data-section="${sectionId}"]`) /* main/quick-add */ ||
      //   html.getElementById(`shopify-section-${sectionId}`); /* featured product*/

      // this.swapProductUtility.viewTransition(oldContent, response);
    };
  }

  handleUpdateProductInfo(sectionId) {
    return (html) => {
      this.updatePickupAvailability();
      this.updateMedia(html);
      const priceDestination = document.getElementById(`price-${this.dataset.section}`);
      const priceSource = html.getElementById(`price-${sectionId}`);
      const skuSource = html.getElementById(`Sku-${sectionId}`);
      const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
      const inventorySource = html.getElementById(`Inventory-${sectionId}`);
      const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

      const volumePricingSource = html.getElementById(`Volume-${sectionId}`);

      const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
      const pricePerItemSource = html.getElementById(`Price-Per-Item-${sectionId}`);

      const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
      const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
      const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

      if (volumeNote) volumeNote.classList.remove('hidden');
      if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
      if (qtyRules) qtyRules.classList.remove('hidden');
      if (priceSource && priceDestination) priceDestination.innerHTML = priceSource.innerHTML;
      if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
      if (skuSource && skuDestination) {
        skuDestination.innerHTML = skuSource.innerHTML;
        skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
      }
      if (volumePricingSource && volumePricingDestination) {
        volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
      }
      if (pricePerItemSource && pricePerItemDestination) {
        pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
        pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
      }

      const price = document.getElementById(`price-${this.dataset.section}`);
      if (price) price.classList.remove('hidden');

      if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

      const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
      this.toggleAddButton(
        addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
        window.variantStrings.soldOut
      );

      this.updateOptionValues(html);

      publish(PUB_SUB_EVENTS.variantChange, {
        data: {
          sectionId,
          html,
          variant: this.currentVariant,
        },
      });
    };
  }

  updateOptionValues(html) {
    const variantSelects = html.querySelector('variant-selects');
    if (variantSelects) this.innerHTML = variantSelects.innerHTML;
  }

  renderProductInfo(sectionId, url, targetId, callback) {
    const params = this.currentVariant
      ? `variant=${this.currentVariant?.id}`
      : `option_values=${this.getSelectedOptionValues().join(',')}`;

    this.abortController?.abort();
    this.abortController = new AbortController();

    ProductUtils.setLoading(true);
    fetch(`${url}?section_id=${sectionId}&${params}`, {
      signal: this.abortController.signal,
    })
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        callback(html);
      })
      .then(() => {
        // set focus to last clicked option value
        const focusTarget = document.getElementById(targetId);
        if (focusTarget) focusTarget.focus({ focusVisible: false });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }
  }

  setUnavailable() {
    this.toggleAddButton(true, '', true);
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getInputSelector() {
    return 'variant-selects fieldset input[type="radio"], variant-selects select option';
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
  }

  connectedCallback() {
    this.initializeRecommendations();

    this.unsubscribeFromSectionRefresh = subscribe(PUB_SUB_EVENTS.sectionRefreshed, (event) => {
      const sectionId = this.dataset.sectionShopifyId;
      const isRelatedProduct = this.classList.contains('related-products');
      const isParentSectionUpdated = sectionId && (event.data?.sectionId ?? '') === `${sectionId.split('__')[0]}__main`;

      if (isRelatedProduct && isParentSectionUpdated) {
        this.dataset.productId = event.data.resource.id;
        this.initializeRecommendations();
      }
    });
  }

  disconnectedCallback() {
    this.unsubscribeFromSectionRefresh();
  }

  initializeRecommendations() {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations();
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations() {
    fetch(`${this.dataset.url}&product_id=${this.dataset.productId}&section_id=${this.dataset.sectionShopifyId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class ProductInfoState {
  // this class will keep track of the state of all <details> within <product-info>
  // this means telling whether they are open and the scroll position within them

  // this is a static class

  static states = new Map();
  static scrollableSurfaceSelector = '.swatch-scroll-container';

  static saveState() {
    const productContentBodyScrollState = document.querySelector('.product-content-body').scrollTop;
    // console.log({ productContentBodyScrollState });
    this.set('product-content-body-scroll', productContentBodyScrollState);

    // Saves state of all additional products details that have at least one item selected
    const additionalProductsDetails = [...document.querySelectorAll('additional-items details')]
      .filter((el) => {
        return el.querySelector('.additional-items__option.selected');
      })
      .map((el) => {
        return el.cloneNode(true);
      });

    this.set('additional-products', additionalProductsDetails);
    // const allDetails = document.querySelectorAll('product-info details');

    // for (let detail of allDetails) {
    //   const id = detail.id;
    //   const scrollableSurface = detail.querySelector(this.scrollableSurfaceSelector);

    //   const state = {
    //     open: detail.open,
    //     scrollTop: scrollableSurface?.scrollTop,
    //     scrollLeft: scrollableSurface?.scrollLeft,
    //   };
    //   this.set(id, state);
    // }

    const allAnimatedAccordions = document.querySelectorAll('animated-accordion-mobile-slideover');
    for (let accordion of allAnimatedAccordions) {
      const id = accordion.getAttribute('id');
      const scrollableSurface = accordion.querySelector('.animated-accordion-mobile-slideover__content');
      const dialogScrollTop = accordion.querySelector("dialog")?.scrollTop || 0;
      const state = {
        open: accordion._isOpen(),
        scrollTop: scrollableSurface?.scrollTop,
        scrollLeft: 0,
        dialogScrollTop
      };

      this.set(id, state);
    }
  }

  static restoreState(productInfoElement) {
    if (!productInfoElement) {
      productInfoElement = document.querySelector('product-info');
    }

    if (!productInfoElement) return;

    const productContentBodyScrollState = this.get('product-content-body-scroll');
    if (productContentBodyScrollState) {
      setTimeout(() => {
        document.querySelector('.product-content-body').scrollTop = productContentBodyScrollState;
      }, 1);
    }

    // Restore state for animated accordion elements
    const allAnimatedAccordions = productInfoElement.querySelectorAll('animated-accordion-mobile-slideover');
    for (let accordion of allAnimatedAccordions) {
      const id = accordion.getAttribute('id');
      const state = this.get(id);

      if (!state) continue;

      if (state.open) {
        accordion._open();
      }

      const isMobile = window.innerWidth < 768;

      if (isMobile) {
        const scrollableSurface = accordion.querySelector('.animated-accordion-mobile-slideover__content');
        if (scrollableSurface) {
          scrollableSurface.scrollTop = state.scrollTop;
        }

        const dialog = accordion.querySelector("dialog");
        if (dialog) {
          setTimeout(() => {
            dialog.scrollTop = state.dialogScrollTop;
          }, 1);
        }
      }
    }
  }

  static get(id) {
    return this.states.get(id);
  }

  static set(id, state) {
    this.states.set(id, state);
  }

  static renderRestoredSection(html) {
    // to be able to restore the scroll position the element will need to be in the dom
    // so what we'll do is that we will put this section with position absolute, left -9999px
    // restore the state and then replace the section with the new html

    ProductInfoState.saveState();

    let doc;
    if (typeof html == 'string') {
      const parser = new DOMParser();
      doc = parser.parseFromString(html, 'text/html');
    } else {
      doc = html;
    }

    // append the saved details from the previous version inside additional-items
    const additionalItems = doc.querySelector('additional-items');
    const additionalProductsDetails = ProductInfoState.get('additional-products');

    const newSection = doc.querySelector('.mh-section');
    newSection.classList.add('product-info--temp');

    // insert new section right after the old one
    const staleProductSection = document.querySelector('product-info').closest('section');
    const parentSection = staleProductSection.parentElement;
    staleProductSection.insertAdjacentElement('afterend', newSection);
    const newProductInfo = newSection.querySelector('product-info');

    // update additional items state
    const additionalItemState = staleProductSection.querySelector('additional-items')?.getState();
    const newAdditionalItems = newSection.querySelector('additional-items');
    if (newAdditionalItems && additionalItemState) {
      newAdditionalItems.setState(additionalItemState);
    }

    // update main quantity input
    const staleQuantityInput = staleProductSection.querySelector('.submit-form quantity-input');
    const newQuantityInput = newSection.querySelector('.submit-form quantity-input');
    if (newQuantityInput && staleQuantityInput) {
      newQuantityInput.setQuantity(staleQuantityInput.input.value);
    }

    ProductInfoState.restoreState(newProductInfo);

    // MH-320: when the upholstery is changed, update the additional items
    // to use the new upholstery, keep the accordion state
    if (additionalItems && additionalProductsDetails) {
      additionalProductsDetails.forEach((detail) => {
        // check that there isn't already a detail with the same id
        if (!doc.getElementById(detail.getAttribute('id'))) {
          const quantityInputs = detail.querySelectorAll('quantity-input');
          quantityInputs.forEach((quantityInput, index) => {
            const quantity = quantityInput.getQuantity();
            const qInput = additionalItems.querySelector(`li:nth-child(${index + 1}) quantity-input`);

            qInput.setQuantity(quantity);
          });
        }
      });

      const staleAdditionalItemsDetails = [...staleProductSection.querySelectorAll('additional-items details')];
      const newAdditionalItemsDetails = [...newSection.querySelectorAll('additional-items details')];
      newAdditionalItemsDetails.forEach((detail, i) => {
        const matchingDetail = staleAdditionalItemsDetails?.[i];
        if (matchingDetail) {
          detail.open = matchingDetail.open;
        }
      });
    }

    // Only wait for the critical featured image(s) to load, not all images.
    // Force eager loading and high fetch priority on them.
    const criticalImgs = [
      newSection.querySelector('.product__featured-image-container img'),
      newSection.querySelector('.product__featured-image'),
      newSection.querySelector('.animated-accordion-mobile-slideover__image img')
    ].filter(Boolean);

    // Force eager loading on critical images so the browser loads them immediately
    criticalImgs.forEach(img => {
      img.loading = 'eager';
      img.setAttribute('fetchpriority', 'high');
      // Remove any lazy-loading data attributes that might interfere
      img.removeAttribute('data-src');
    });

    function waitForImages() {
      if (criticalImgs.length === 0) {
        return Promise.resolve('No critical images to load');
      }

      const imagePromises = criticalImgs.map(img => {
        return new Promise((resolve) => {
          // If image is already loaded (e.g. from prefetch cache)
          if (img.complete && img.naturalHeight !== 0) {
            resolve(img);
            return;
          }

          const onLoad = () => { cleanup(); resolve(img); };
          const onError = () => { cleanup(); resolve(img); };
          const cleanup = () => {
            img.removeEventListener('load', onLoad);
            img.removeEventListener('error', onError);
          };

          img.addEventListener('load', onLoad, { once: true });
          img.addEventListener('error', onError, { once: true });

          // Force the image to start loading if it has lazy loading
          if (img.src && !img.complete) {
            const currentSrc = img.src;
            img.src = '';
            img.src = currentSrc;
          }

          // Timeout after 3 seconds to prevent indefinite waiting
          setTimeout(() => { cleanup(); resolve(img); }, 3000);
        });
      });

      return Promise.all(imagePromises);
    }

    // remove the old section and remove the temp class
    staleProductSection.remove();
    newSection.classList.remove('product-info--temp');

    // Update additional items price after variant change and state restoration
    const restoredAdditionalItems = newSection.querySelector('additional-items');
    const priceElement = newSection.querySelector('.product-form__price');
    
    // Hide price during computation to prevent flashing
    if (priceElement) {
      priceElement.style.opacity = '0';
    }
    
    setTimeout(() => {
      if (restoredAdditionalItems) {
        // Update the original price with the new variant price
        restoredAdditionalItems.originalPrice = restoredAdditionalItems.getOriginalProductPrice();
        // Recalculate and update the total price
        restoredAdditionalItems.updateMainProductPrice();
      }
      
      // Restore price visibility after computation
      if (priceElement) {
        priceElement.style.opacity = '1';
      }

      const newProductInfo = newSection.querySelector('product-info');
      const deliveryTime = newProductInfo.dataset.deliveryTime;
      const oldDeliveryTime = document.querySelector("[data-delivery-message-template]")
      // fixes delivery time issues with modals https://lyradesigns.atlassian.net/browse/MH-1078
      if (oldDeliveryTime && oldDeliveryTime.dataset.deliveryMessageTemplate?.includes('modal-trigger text') === false) {
        const deliveryTimeTemplate = oldDeliveryTime.dataset.deliveryMessageTemplate;
        oldDeliveryTime.textContent = deliveryTimeTemplate.replace('[[override_min]]', deliveryTime);
      }

      // Reinitialize product specs toggle after variant change
      const productContainer = newSection.querySelector('product-container');
      if (productContainer) {
        // The ProductContainer custom element should already be initialized by the browser
        // But we need to ensure the event listeners are properly attached
        // Since the element was just created, we might need to wait for the next tick
        setTimeout(() => {
          if (productContainer.initProductSpecsToggle) {
            productContainer.initProductSpecsToggle();
          }
        }, 0);
      }

      waitForImages().then(() => {
        parentSection.classList.remove('product--updating');
      });
    }, 50); // Small delay to ensure DOM is fully updated
  }
}

class VariantPickerSelect extends HTMLElement {
  constructor() {
    super();
    this._prefetchCache = new Map();
    this._prefetchInFlight = new Map(); // handle -> { promise, controller }
    this._prefetchAbortControllers = new Map(); // handle -> AbortController

    const swatches = this.querySelectorAll('button.swatch-item');
    swatches.forEach((swatch) => {
      swatch.addEventListener('click', this.handleSwatchClick.bind(this));
      swatch.addEventListener('mouseenter', this.handleSwatchHover.bind(this));
      swatch.addEventListener('pointerdown', this.handleSwatchHover.bind(this));
      swatch.addEventListener('touchstart', this.handleSwatchTouchStart.bind(this), { passive: true });
    });
    this.scrollSelectedOptionIntoView();
    this._setupVisibilityPrefetch();
    this._setupAccordionOpenPrefetch();

    // Invalidate prefetch cache when variant radio options change
    this._radioChangeHandler = () => {
      this._prefetchCache.clear();
      this._abortAllPrefetches();
    };
    document.addEventListener('change', (e) => {
      if (e.target.matches && e.target.matches('variant-selects input[type="radio"]')) {
        this._radioChangeHandler();
      }
    });
  }

  scrollSelectedOptionIntoView() {
    // If there is saved state don't scroll here as the scrolling user's position will be restored
    if (ProductInfoState.states.size !== 0) return;

    const selected = this.querySelector('.swatch--selected')?.closest('.variant-picker-select__group');
    if (selected) {
      const top = selected.offsetTop - this.offsetTop;
      this.scrollTo({ top: top - 30 });
    }
  }

  _buildOptionsPayload() {
    const allRadios = document.querySelectorAll(".product fieldset [type='radio']:checked");
    return Array.from(allRadios).map((radio) => ({
      name: radio.name.split('-')?.[0],
      value: radio.value,
    }));
  }

  async _fetchSwatchData(handle, signal) {
    const selects = this._buildOptionsPayload();
    const encodedOptions = encodeURIComponent(JSON.stringify({ options: selects }));

    const fetchOpts = signal ? { method: 'GET', signal } : { method: 'GET' };

    const variantResponse = await fetch(
      `https://mh-functions.netlify.app/.netlify/functions/get-variant-id?options=${encodedOptions}&handle=${handle}`,
      fetchOpts
    );

    const { id } = await variantResponse.json();
    const url = id ? `/products/${handle}?variant=${id}` : `/products/${handle}`;
    const sectionFetchUrl = id
      ? `${url}&section_id=${this.dataset.sectionId}`
      : `${url}?section_id=${this.dataset.sectionId}`;

    const section = await fetch(sectionFetchUrl, signal ? { signal } : {});
    const html = await section.text();

    return { id, url, html };
  }

  _preloadFeaturedImage(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const featuredImg = doc.querySelector('.product__featured-image-container img') ||
                        doc.querySelector('.product__featured-image');
    if (featuredImg && featuredImg.src) {
      const preloadImg = new Image();
      preloadImg.src = featuredImg.src;
    }
  }

  _abortAllPrefetches() {
    for (const [, controller] of this._prefetchAbortControllers) {
      controller.abort();
    }
    this._prefetchAbortControllers.clear();
    this._prefetchInFlight.clear();
  }

  _startPrefetch(handle) {
    if (this._prefetchCache.has(handle) || this._prefetchInFlight.has(handle)) return;

    const controller = new AbortController();
    this._prefetchAbortControllers.set(handle, controller);

    const prefetchPromise = this._fetchSwatchData(handle, controller.signal).then((result) => {
      this._prefetchCache.set(handle, result);
      this._preloadFeaturedImage(result.html);
      return result;
    }).catch((err) => {
      if (err.name === 'AbortError') return null;
      return null;
    }).finally(() => {
      this._prefetchInFlight.delete(handle);
      this._prefetchAbortControllers.delete(handle);
    });

    this._prefetchInFlight.set(handle, prefetchPromise);
  }

  handleSwatchHover(event) {
    const targetButton = event.target.closest('button');
    if (!targetButton) return;
    const handle = targetButton.dataset.handle;

    if (targetButton.classList.contains('swatch--selected')) return;
    this._startPrefetch(handle);
  }

  handleSwatchTouchStart(event) {
    const targetButton = event.target.closest('button');
    if (!targetButton) return;
    const handle = targetButton.dataset.handle;

    if (targetButton.classList.contains('swatch--selected')) return;

    // Abort all other in-flight prefetches — prioritize the touched swatch
    for (const [inflightHandle, controller] of this._prefetchAbortControllers) {
      if (inflightHandle !== handle) {
        controller.abort();
        this._prefetchAbortControllers.delete(inflightHandle);
        this._prefetchInFlight.delete(inflightHandle);
      }
    }

    this._startPrefetch(handle);
  }

  _setupVisibilityPrefetch() {
    // Use IntersectionObserver to prefetch visible swatches as user scrolls
    // Limited to a few at a time to avoid flooding the network
    if (!('IntersectionObserver' in window)) return;

    this._visibilityObserver = new IntersectionObserver((entries) => {
      const visibleHandles = [];
      for (const entry of entries) {
        if (entry.isIntersecting) {
          const btn = entry.target;
          const handle = btn.dataset.handle;
          if (handle && !btn.classList.contains('swatch--selected') &&
              !this._prefetchCache.has(handle) && !this._prefetchInFlight.has(handle)) {
            visibleHandles.push(handle);
          }
        }
      }

      // Limit to 2 concurrent prefetches from scroll visibility
      const currentInFlight = this._prefetchInFlight.size;
      const maxFromScroll = Math.max(0, 2 - currentInFlight);
      visibleHandles.slice(0, maxFromScroll).forEach((handle) => {
        this._startPrefetch(handle);
      });
    }, {
      root: null,
      rootMargin: '100px',
      threshold: 0.1
    });

    // Observe all swatch buttons
    this.querySelectorAll('button.swatch-item').forEach((btn) => {
      if (!btn.classList.contains('swatch--selected')) {
        this._visibilityObserver.observe(btn);
      }
    });
  }

  _setupAccordionOpenPrefetch() {
    // On desktop, swatches are inside <details> accordions that start closed.
    // When accordion opens, trigger prefetch for visible swatches.
    const parentDetails = this.closest('details');
    if (!parentDetails) return;

    parentDetails.addEventListener('toggle', () => {
      if (parentDetails.open && this._visibilityObserver) {
        // Small delay to let the accordion content render/layout
        setTimeout(() => {
          // Re-observe swatches to trigger intersection checks
          this.querySelectorAll('button.swatch-item').forEach((btn) => {
            if (!btn.classList.contains('swatch--selected') &&
                !this._prefetchCache.has(btn.dataset.handle)) {
              this._visibilityObserver.unobserve(btn);
              this._visibilityObserver.observe(btn);
            }
          });
        }, 50);
      }
    });
  }

  // let's replicate handleChange but with swatches buttons now
  async handleSwatchClick(event) {
    event.preventDefault();
    ProductUtils.setLoading(true);
    const startTime = performance.now();
    try {
      const submitBtn = this.closest('section').querySelector('[type=submit]');
      const parentSection = this.closest('.shopify-section');
      submitBtn.disabled = true;
      const targetButton = event.target.closest('button');
      const handle = targetButton.dataset.handle;

      // set parent section class
      parentSection.classList.add('product--updating');

      let result;

      // Check prefetch cache first, then in-flight, then fetch fresh
      if (this._prefetchCache.has(handle)) {
        result = this._prefetchCache.get(handle);
        this._prefetchCache.delete(handle);
      } else if (this._prefetchInFlight.has(handle)) {
        result = await this._prefetchInFlight.get(handle);
      }

      if (!result) {
        result = await this._fetchSwatchData(handle);
      }

      const { url, html } = result;
      history.replaceState(null, '', url);

      // Wait just long enough for the fade-out transition to be visible
      const elapsed = performance.now() - startTime;
      const minFadeTime = 150;
      const remaining = Math.max(0, minFadeTime - elapsed);

      setTimeout(function(){
        ProductInfoState.renderRestoredSection(html);
      }, remaining);

    } finally {
      ProductUtils.setLoading(false);

      trackOptionSelected(
        this.querySelector('.form__label')?.innerText,
        event.target.getAttribute('aria-label')?.split(' - ')[1]
      );
    }
  }
}

customElements.define('variant-picker-select', VariantPickerSelect);

class ProductUtils {
  static setLoading(value) {
    const productContainer = document.querySelector('.product');
    if (productContainer) {
      productContainer.classList.toggle('product--loading', value);
    }
  }
}

class TooltipTrigger extends HTMLElement {
  static currentTooltip = null; // Track the currently active tooltip

  constructor() {
    super();
    this._tooltip = this.dataset.target
      ? document.getElementById(this.dataset.target)
      : this.closest('section')?.querySelector('.tooltip');

    if (!this._tooltip) {
      return;
    }

    this._tooltipTitle = this._tooltip.querySelector('.tooltip-title');
    this._tooltipImage = this._tooltip.querySelector('.tooltip-image');
    this._popperInstance = null;

    this._boundShowTooltip = this._showTooltip.bind(this);
    this._boundHideTooltip = this._hideTooltip.bind(this);
    this._boundKeepTooltipVisible = this._keepTooltipVisible.bind(this);
    this._boundHideTooltipOnScroll = this._hideTooltipOnScroll.bind(this);

    this.scrollTarget = this.closest('variant-picker-select') || window;
  }

  connectedCallback() {
    this._swatch = this.querySelector('.swatch-item');
    this._title = this.getAttribute('data-title');
    this._image = this.getAttribute('data-image');

    this._swatch.addEventListener('mouseenter', this._boundShowTooltip);
    this._swatch.addEventListener('mouseleave', this._boundHideTooltip);
    this._tooltip.addEventListener('mouseenter', this._boundKeepTooltipVisible);
    this._tooltip.addEventListener('mouseleave', this._boundHideTooltip);
    this.scrollTarget.addEventListener('scroll', this._boundHideTooltipOnScroll, {
      passive: true,
    });
  }

  disconnectedCallback() {
    this._swatch.removeEventListener('mouseenter', this._boundShowTooltip);
    this._swatch.removeEventListener('mouseleave', this._boundHideTooltip);
    this._tooltip.removeEventListener('mouseenter', this._boundKeepTooltipVisible);
    this._tooltip.removeEventListener('mouseleave', this._boundHideTooltip);
    this.scrollTarget.removeEventListener('scroll', this._boundHideTooltipOnScroll);
  }

  _showTooltip() {
    clearTimeout(TooltipTrigger.currentTooltip);
    this._tooltipTitle.textContent = this._title;
    this._tooltipImage.src = this._image;
    this._tooltip.classList.add('tooltip--visible');

    if (this._popperInstance) {
      this._popperInstance.destroy();
    }

    this._popperInstance = Popper.createPopper(this._swatch, this._tooltip, {
      placement: 'bottom',
      strategy: 'fixed',
      modifiers: [
        { name: 'flip', options: { fallbackPlacements: ['top', 'right', 'left'] } },
        { name: 'preventOverflow', options: { boundary: 'viewport' } },
        { name: 'offset', options: { offset: [0, 8] } },
      ],
    });

    // fix tooltip position if the library mispositions it
    if (this._popperInstance.state.elements.popper.getBoundingClientRect().y < 0) {
      this._popperInstance.forceUpdate();
    }
  }

  _hideTooltip() {
    TooltipTrigger.currentTooltip = setTimeout(() => {
      this._hideTooltipImmediately();
    }, 100); // Allow a short delay to handle quick mouse transitions
  }

  _hideTooltipImmediately() {
    this._tooltip.classList.remove('tooltip--visible');
    if (this._popperInstance) {
      this._popperInstance.destroy();
      this._popperInstance = null;
    }
  }

  _keepTooltipVisible() {
    clearTimeout(TooltipTrigger.currentTooltip);
  }

  _hideTooltipOnScroll() {
    this._hideTooltipImmediately();
  }
}

let loadedPopper = false;

function registerTooltipTrigger() {
  if (!loadedPopper) {
    const popperUrl = document.body.getAttribute('data-tooltip-url');
    if (popperUrl) {
      const script = document.createElement('script');
      // load script
      script.src = popperUrl;
      script.async = true;
      document.head.appendChild(script);

      loadedPopper = true;
      script.onload = () => {
        customElements.define('tooltip-trigger', TooltipTrigger);
      };
    }
  } else {
    customElements.define('tooltip-trigger', TooltipTrigger);
  }
}

const tooltipMediaQuery = '(min-width: 768px)';
if (window.matchMedia(tooltipMediaQuery).matches) {
  registerTooltipTrigger();
}

window.matchMedia(tooltipMediaQuery).addEventListener('change', (event) => {
  if (event.matches) {
    registerTooltipTrigger();
  } else {
    document.querySelector('.tooltip')?.classList.remove('tooltip--visible');
  }
});

class ModalTrigger extends HTMLElement {
  constructor() {
    super();
    
    // A template can repeat a section (one per A/B variant), repeating its modal ids too.
    // Look in the trigger's own section first, so a visible trigger never opens a hidden copy.
    const modalId = this.getAttribute('data-modal');
    const ownSection = this.closest('.shopify-section');
    this.modal = modalId
      ? ownSection?.querySelector(`#${CSS.escape(modalId)}`) || document.getElementById(modalId)
      : this.closest('section')?.querySelector('.modal');
      if (!this.modal) return;

    this.copyModal = this.dataset.copyModal == 'true';
    // A modal from another section (e.g. the shared modals section) opens down in that
    // section, far from the trigger. With data-adopt-modal, open a copy beside this
    // section's own modals instead. Drawers are fixed to the viewport, so they stay put.
    const adoptInto =
      this.dataset.adoptModal == 'true' &&
      !this.copyModal &&
      ownSection &&
      !ownSection.contains(this.modal) &&
      !this.modal.classList.contains('modal--drawer')
        ? ownSection.querySelector('.modal')?.parentElement || this.parentElement
        : null;
    // if this.copyModal is true, we need to copy the modal to the parent element of this trigger and update the modal trigger to open the copy
    if (this.copyModal || adoptInto) {
      const modalClone = this.modal.cloneNode(true);
      (adoptInto || this.parentElement).appendChild(modalClone);
      this.modal = modalClone;
      this.modal.id = this.modal.id + (adoptInto ? `-${ownSection.id}` : '-copy');
      this.modal.setAttribute('aria-hidden', 'true');
    }

    this.modalContainer = this.dataset.modalContainer ? this.modal.closest(this.dataset.modalContainer) || document.querySelector(this.dataset.modalContainer) : this.modal.parentElement;
    this.modalBoundary = this.dataset.modalBoundary ? this.modal.closest(this.dataset.modalBoundary) || document.querySelector(this.dataset.modalBoundary) : this.closest('section');
    this.closeButton = this.modal?.querySelector('.modal__toggle');
    this.freezeScroll = this.dataset.freezeScroll == 'true';
    this.hideOnScroll = this.dataset.hideOnScroll !== 'false'; // Default to true unless explicitly set to 'false'
    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.scrollOnOpen = this.dataset.scrollOnOpen !== 'false'; // Default to true unless explicitly set to 'false'
    this.scrollTarget = this.closest('body') || window;

    this.modal.show = this.showModal.bind(this);
    this.modal.hide = this.hideModal.bind(this);

    this.modal.style.setProperty('--max-width', this.dataset.maxWidth || '448px');

    // Event listeners
    this.modal.addEventListener('keyup', this.onKeyUp.bind(this));
    this.modal.addEventListener('click', this.onModalClick.bind(this));
    this._clickedTrigger = null;
    this._isHiding = false; // Add this flag
    this._keyboardOpen = false;
  }

  connectedCallback() {
    this.addEventListener('click', this.showModal);
    this.closeButton?.addEventListener('click', this.hideModal);
    this.addEventListener('keydown', this.onTriggerKeyDown.bind(this));

    this.modal && this.modalContainer && this.modalBoundary &&
      document.addEventListener('DOMContentLoaded', () => {
        const modalContainer = this.modalContainer.parentElement.getBoundingClientRect();
        const modalBoundary = this.modalBoundary.parentElement.getBoundingClientRect();
        this.modal.style.setProperty(
          '--modal-max-height',
          `calc(${modalContainer.top - modalBoundary.top + modalContainer.height}px - 40px)`
        );
      });

    this.hideOnScroll &&
      window.addEventListener('scroll', this.onScroll.bind(this), {
        passive: true,
      });

  }

  disconnectedCallback() {
    // this.scrollTarget.removeEventListener('scroll', this._boundHideModalOnScroll);
    this.removeEventListener('click', this.showModal);
    this.closeButton?.removeEventListener('click', this.hideModal);
  }

  showModal(e) {
    if (e.target.tagName.toLowerCase() === 'modal-trigger') {
      this._clickedTrigger = e.target;
    }

    if (this.closest('.slideover-dialog') && isMobile()) {
      this.closest('.slideover-dialog').close();
    }

    document.querySelectorAll('.modal--visible').forEach((modal) => {
      modal.classList.remove('modal--visible');
      modal.setAttribute('aria-hidden', 'true');
    });

    this.modal.setAttribute('aria-hidden', 'false');
    this.modal.classList.add('modal--visible');

    this.closeButton.setAttribute('tabindex', '0');
    // Skip scroll-into-view for drawer modals (they're fixed position and don't need scrolling)
    if (this.scrollOnOpen && !this.modal.classList.contains('modal--drawer')) {
      const rect = this.modal.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      let bottomOffset = 24;
      const modalBottom = rect.bottom;
      const desiredBottom = windowHeight - bottomOffset;
      const offset = modalBottom - desiredBottom;
      if (!isMobile() && offset !== 0) {
        window.scrollBy({ top: offset, behavior: 'smooth' });
      }
    }

    // Only trap focus and focus close button if opened via keyboard
    if (this._keyboardOpen) {
      setTimeout(() => {
        // `.modal__toggle` rather than [aria-label="Close"]: the label is translated,
        // so the attribute selector stops matching outside English.
        trapFocus(this.modal, this.closeButton, { focusVisible: true });
      }, 500);
    } else {
      // For mouse interactions, blur any focused element to prevent focus outline
      if (document.activeElement && document.activeElement !== document.body) {
        document.activeElement.blur();
      }
    }
    setTimeout(() => {
      this.freezeScroll && document.body.classList.add('overflow-hidden');
    }, 300);

    const openEvent = new CustomEvent('modal:open', {
      bubbles: true,
      composed: true,
      detail: {
        modal: this.modal,
      },
    });
    this.modal.dispatchEvent(openEvent);
  }

  hideModal(e) {
    if (this._isHiding) return; // Prevent multiple calls
    this._isHiding = true;

    this.freezeScroll && document.body.classList.remove('overflow-hidden');
    setTimeout(() => {
      // Return focus to trigger if opened by keyboard, otherwise blur
      if (this._keyboardOpen && this._clickedTrigger) {
        removeTrapFocus(this._clickedTrigger);
      } else {
        document.activeElement.blur();
      }
      e?.type == 'scroll' ? document.activeElement.blur() : removeTrapFocus(this._clickedTrigger);
      this.modal.setAttribute('aria-hidden', 'true');
      this.modal.classList.remove('modal--visible');
      this.closeButton.setAttribute('tabindex', '-1');
      removeTrapFocus(this.openedBy);
      this._isHiding = false; // Reset flag after hide completes
      this._clickedTrigger = null;
      this._keyboardOpen = false;
    }, 300);
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    
    this.hideModal();
  }

  onTriggerKeyDown(event) {
    if (event.code.toUpperCase() === 'ENTER' || event.code.toUpperCase() === 'SPACE') {
      event.preventDefault();
      this._keyboardOpen = true;
      this.showModal(event);
    }
  }

  onModalClick(e) {
    // Only close if clicking directly on the modal backdrop (not on its children)
    // This prevents closing when clicking on modal content, including select dropdowns
    if (e.target === this.modal && this.modal.getAttribute('aria-hidden') === 'false') {
      this.hideModal(e);
    }
  }

  onScroll(e) {
    if (this.modal?.getAttribute('aria-hidden') == 'false') {
      const rect = this.modal.getBoundingClientRect();
      const isOffScreen = rect.top * -1 > (rect.height / 2) || rect.top > window.innerHeight - (rect.height / 2);
      if (isOffScreen) {
        this.hideModal(e);
      }
    }
  }
}

customElements.define('modal-trigger', ModalTrigger);

// can re-activate this if we want to dynamically create modalTriggers from a links
// const modalTriggerLinks = document.querySelectorAll('[href*="#modal-"]');

// modalTriggerLinks.forEach((link) => {
//   // change <a> to <modalTrigger>
//   const modalTrigger = document.createElement('modal-trigger');
//   // copy all attributes
//   for (let i = 0; i < link.attributes.length; i++) {
//     modalTrigger.setAttribute(link.attributes[i].name, link.attributes[i].value);
//     modalTrigger.setAttribute('data-modal', link.getAttribute('href').split('#')[1]);
//   }
//   // copy all children
//   while (link.firstChild) {
//     modalTrigger.appendChild(link.firstChild);
//   }
//   // replace <a> with <modalTrigger>
//   link.parentNode.replaceChild(modalTrigger, link);
// });

// if (modalTriggerLinks.length > 0) {
//  customElements.define('modal-trigger', ModalTrigger);
// }

class AdditionalItems extends HTMLElement {
  constructor() {
    super();
    this.initQuantityInputs();
    this.addEventListener('animated-accordion-rerendered', () => {
      this.initQuantityInputs();
    });
    // Store the original product price
    this.originalPrice = this.getOriginalProductPrice();
    
    // Listen for variant changes to update the original price
    this.setupVariantChangeListener();
  }

  setupVariantChangeListener() {
    // Listen for variant change events using the pub/sub system
    this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      // Use a small delay to ensure ProductInfo has updated first
      setTimeout(() => {
        // Notify ProductInfo to update pricing after variant change
        const productInfo = document.querySelector('product-info');
        if (productInfo && typeof productInfo.updateProductFormPrice === 'function') {
          productInfo.updateProductFormPrice();
        } else {
          // Fallback: Update using the old method if ProductInfo doesn't support new method
          this.originalPrice = this.getOriginalProductPrice();
          this.updateMainProductPrice();
        }
      }, 100); // Small delay to ensure ProductInfo and variant change processing is complete
    });
  }

  disconnectedCallback() {
    // Clean up event listeners when component is removed
    if (this.variantChangeUnsubscriber) {
      this.variantChangeUnsubscriber();
    }
  }

  initQuantityInputs() {
    const quantityInputs = this.querySelectorAll('quantity-input');
    quantityInputs.forEach((quantityInput) => {
      quantityInput.querySelector('input').addEventListener('change', (e) => {
        const variantContainer = e.target.closest('li');
        if (e.target.value > 0) {
          variantContainer.classList.add('selected');
        } else {
          variantContainer.classList.remove('selected');
        }
        this.updateGroupLabel(e.target.closest('.additional-items__items'));
        
        // Notify ProductInfo to update the main product price
        const productInfo = document.querySelector('product-info');
        if (productInfo && typeof productInfo.updateProductFormPrice === 'function') {
          productInfo.updateProductFormPrice();
        } else {
          // Fallback: Update using the old method if ProductInfo doesn't support new method
          this.updateMainProductPrice();
        }
      });
    });
  }

  updateGroupLabel(group) {
    if (!group) return;

    const selectionLabel = group.querySelector('.additional-items__selection');
    const inputs = group.querySelectorAll('.quantity__input');

    let totalValueOfInputs = 0;
    for (const input of inputs) {
      totalValueOfInputs += Number.parseInt(input.value);
    }

    if (totalValueOfInputs > 0) {
      selectionLabel.textContent = totalValueOfInputs === 1 ? '1 item' : `${totalValueOfInputs} items`;
    } else {
      selectionLabel.textContent = '';
    }
  }

  getOriginalProductPrice() {
    const priceElement = document.querySelector('.product-form__price');
    if (priceElement && priceElement.textContent.trim()) {
      try {
        // Extract the price text and parse it to get the numeric value
        const priceText = priceElement.textContent.trim();
        // Remove currency symbols and commas, then parse
        const numericPrice = parseFloat(priceText.replace(/[^0-9.-]/g, ''));
        if (!isNaN(numericPrice)) {
          return numericPrice * 100; // Convert to cents for calculation
        }
      } catch (error) {
        console.warn('Error parsing original product price:', error);
      }
    }
    return 0;
  }

  calculateAdditionalItemsTotal() {
    let total = 0;
    const inputs = this.querySelectorAll('quantity-input input');
    
    inputs.forEach((input) => {
      try {
        const quantity = parseInt(input.value) || 0;
        if (quantity > 0) {
          const variantContainer = input.closest('li');
          const priceElement = variantContainer?.querySelector('.additional-items__price');
          if (priceElement && priceElement.textContent.trim()) {
            // Extract price from the element
            const priceText = priceElement.textContent.trim();
            const numericPrice = parseFloat(priceText.replace(/[^0-9.-]/g, ''));
            if (!isNaN(numericPrice)) {
              total += (numericPrice * 100) * quantity; // Convert to cents and multiply by quantity
            }
          }
        }
      } catch (error) {
        console.warn('Error calculating additional item price:', error);
      }
    });
    
    return total;
  }

  formatPrice(priceInCents) {
    try {
      // Format as $8,000 (no cents)
      const dollars = Math.round(priceInCents / 100);
      return '$' + dollars.toLocaleString();
    } catch (error) {
      console.warn('Error formatting price:', error);
      return '$0';
    }
  }

  updateMainProductPrice() {
    const priceElement = document.querySelector('.product-form__price');
    if (priceElement) {
      try {
        // Add transition for smooth opacity changes
        if (!priceElement.style.transition) {
          priceElement.style.transition = 'opacity 0.2s ease';
        }
        
        const additionalTotal = this.calculateAdditionalItemsTotal();
        const newTotalPrice = this.originalPrice + additionalTotal;
        priceElement.textContent = this.formatPrice(newTotalPrice);
      } catch (error) {
        console.warn('Error updating main product price:', error);
      }
    }
  }

  // state is the value of all inputs inside quantity-input
  getState() {
    const state = {};
    const inputs = this.querySelectorAll('quantity-input input');
    inputs.forEach((input) => {
      const key = input.closest('li').getAttribute('data-variant-id');
      state[key] = input.value;
    });
    return state;
  }

  setState(state) {
    const inputs = this.querySelectorAll('quantity-input');
    inputs.forEach((input) => {
      const key = input.closest('li').getAttribute('data-variant-id');
      if (state[key]) {
        input.setQuantity(state[key]);
      }
    });
    
    // Notify ProductInfo to recalculate pricing after setting state
    setTimeout(() => {
      const productInfo = document.querySelector('product-info');
      if (productInfo && typeof productInfo.updateProductFormPrice === 'function') {
        productInfo.updateProductFormPrice();
      } else {
        // Fallback: Update using the old method if ProductInfo doesn't support new method
        this.originalPrice = this.getOriginalProductPrice();
        this.updateMainProductPrice();
      }
    }, 10); // Small delay to ensure quantities are fully set
  }
}

customElements.define('additional-items', AdditionalItems);

class ScrollDetector extends HTMLElement {
  constructor() {
    super();

    // Get the optional offset from the attributes or default to 0%
    this.offsetPercentage = parseFloat(this.getAttribute('data-offset')) || 0;

    // Find the targeted element or default to the first child
    const targetId = this.getAttribute('data-target');
    this.scrollElement = targetId ? document.getElementById(targetId) : this.firstElementChild;

    if (!this.scrollElement) {
      console.error('ScrollDetector: Target element not found');
      return;
    }
  }

  connectedCallback() {
    // Calculate the offset in pixels based on the element's total scrollable height
    const offset = (this.scrollElement.scrollHeight * this.offsetPercentage) / 100;

    // Handler to update data-scrolled attribute
    const handleScroll = () => {
      if (this.scrollElement.scrollTop > offset) {
        this.setAttribute('data-scrolled', 'true');

        // Check if we should persist the scroll state
        if (this.hasAttribute('data-persist-scroll-state')) {
          // Remove the event listener since we no longer need to track scrolling
          this.scrollElement.removeEventListener('scroll', handleScroll);
        }
      } else if (!this.hasAttribute('data-persist-scroll-state')) {
        this.removeAttribute('data-scrolled');
      }
    };

    // Attach scroll event listener with passive option
    this.scrollElement.addEventListener('scroll', handleScroll, { passive: true });

    // Cleanup function to remove event listener
    this.cleanup = () => {
      this.scrollElement.removeEventListener('scroll', handleScroll);
    };

    // if element doesn't have scroll bar, set data-scrolled to true
    if (this.scrollElement.scrollHeight === this.scrollElement.clientHeight) {
      this.setAttribute('data-scrolled', 'true');
    }
  }

  disconnectedCallback() {
    // Run cleanup when the component is removed from the DOM
    if (this.cleanup) {
      this.cleanup();
    }
  }
}

// Define the scroll-detector component
customElements.define('scroll-detector', ScrollDetector);

class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.swatchButtons = this.querySelectorAll('.swatch');
    this.productUrl = this.querySelector('a').getAttribute('href').split('?')[0];
  }

  connectedCallback() {
    this.swatchButtons.forEach((button) => {
      button.addEventListener('click', this.updateSwatch.bind(this));
    });
  }

  async updateSwatch(event) {
    const swatch = event.currentTarget;
    const variantId = swatch.dataset.variantId;
    const request = await fetch(this.productUrl + `?variant=${variantId}&sections=card-product`);
    const answer = await request.json();
    const cardProduct = answer['card-product'];
    const parser = new DOMParser();
    const doc = parser.parseFromString(cardProduct, 'text/html');
    const result = doc.querySelector('product-card');

    if (result) {
      this.outerHTML = result.outerHTML;
    }
  }
}

window.customElements.define('product-card', ProductCard);

Shopify.renderProductsAsCards = async function (products) {
  const promises = products
    .filter((p) => p.handle && p.variant)
    .map(async ({ handle, variant }) => {
      let url = Shopify.routes.root + `products/${handle}`;
      if (variant) {
        url += `?variant=${variant}`;
      }

      const html = await Shopify.renderSection({ url, section_id: 'card-product' });
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      return doc.querySelector('product-card');
    });

  const productCards = await Promise.all(promises);
  return productCards;
};

class ShopTheLook extends HTMLElement {
  constructor() {
    super();
    const itemsButtons = this.querySelectorAll('.shop-the-look__product-dot');
    const products = this.querySelectorAll('product-card');
    const tooltips = this.querySelectorAll('.shop-the-look__tooltip');
    tooltips.forEach((tooltip) => this.positionTooltip(tooltip));

    if (document.body.classList.contains('is-touch-device')) {
      this.querySelector('.shop-the-look__product-dot:first-child').classList.add('shop-the-look__product-dot--active');
    }

    // Function to remove active classes
    const removeActiveClasses = () => {
      itemsButtons.forEach((dot) => dot.classList.remove('shop-the-look__product-dot--active'));
      products.forEach((product) => product.classList.remove('product-card--active'));
    };

    // Event listener for product dots
    itemsButtons.forEach((dot) => {
      dot.addEventListener('click', (event) => {
        event.stopPropagation(); // Prevent click from bubbling to document

        const isAlreadyExpanded = dot.classList.contains('shop-the-look__product-dot--active');
        if (isAlreadyExpanded) {
          removeActiveClasses();
          // add an .inert class to the dot until the next click in the page or until the user moves out
          dot.classList.add('inert');

          // remove after the next click
          const removeInert = () => {
            // console.log('remove inert');
            dot.classList.remove('inert');
            document.removeEventListener('click', removeInert);
            dot.removeEventListener('mouseleave', removeInert);
          };

          document.addEventListener('click', removeInert);
          dot.addEventListener('mouseleave', removeInert);
        } else {
          const productId = dot.dataset.product;

          // Remove active classes from all dots and products
          removeActiveClasses();

          // Add active class to the clicked dot
          dot.classList.add('shop-the-look__product-dot--active');

          // Find the product card with the same data-id and add active class
          const matchingProduct = Array.from(products).find((product) => {
            return product.dataset.id === productId;
          });

          if (matchingProduct) {
            matchingProduct.classList.add('product-card--active');
            // and smooth scroll to it
            // matchingProduct.parentElement.scrollTo({
            //   left: matchingProduct.offsetLeft - 20,
            //   top: 0,
            //   // behavior: 'smooth',
            //   behavior: 'instant'
            // });
          }
        }
      });
    });

    // Clicking anywhere else in the page should remove the active class if on desktop
    !document.body.classList.contains('is-touch-device') && document.addEventListener('click', removeActiveClasses);
  }

  measureTooltipSize(tooltip) {
    // Remember original styles
    const originalVisibility = tooltip.style.visibility;
    const originalPosition = tooltip.style.position;
    const originalDisplay = tooltip.style.display;

    // Temporarily modify styles to measure
    tooltip.style.visibility = 'hidden'; // Make it invisible but still rendered
    tooltip.style.position = 'absolute'; // Position it so it doesn't affect the layout
    tooltip.style.display = 'block'; // Ensure it's not display:none so we can measure it
    tooltip.style.left = '-9999px'; // Move it off-screen

    // Measure
    const width = tooltip.offsetWidth;
    const height = tooltip.offsetHeight;

    // Revert styles
    tooltip.style.visibility = originalVisibility;
    tooltip.style.position = originalPosition;
    tooltip.style.display = originalDisplay;
    tooltip.style.left = ''; // Remove the left property or set it back to original

    return { width, height };
  }

  positionTooltip(tooltip) {
    const tooltipParent = tooltip.parentElement; // Get the parent element of the tooltip
    const parentRect = tooltipParent.getBoundingClientRect(); // Get dimensions and position of the parent
    const { width: tooltipWidth, height: tooltipHeight } = this.measureTooltipSize(tooltip);

    const viewportWidth = window.innerWidth; // Width of the viewport
    const dotPort = tooltip.closest('.shop-the-look__product-dots').getBoundingClientRect(); // bounds of the dot container

    // Calculate available space to the right and left of the parent element
    const spaceToRight = viewportWidth - parentRect.right - dotPort.right;
    const spaceToLeft = parentRect.left - dotPort.left;

    // Determine if the tooltip exceeds the viewport to the right, left, or to the top
    const exceedsRight = spaceToRight < tooltipWidth;
    const exceedsLeft = spaceToLeft < tooltipWidth;
    const exceedsTop = parentRect.top < tooltipHeight;

    // Reset all positioning classes before adding new ones
    tooltip.className = tooltip.className.replace(/card-tooltip__tooltip-\w+-\w+/g, '');

    // console.log(exceedsLeft, exceedsRight, exceedsTop);
    // Determine horizontal positioning
    if (exceedsRight && exceedsLeft) {
      tooltip.classList.add('card-tooltip--x-center');
    } else if (exceedsRight) {
      tooltip.classList.add('card-tooltip--x-right');
    } else {
      tooltip.classList.add('card-tooltip--x-left');
    }

    // Determine vertical positioning
    if (exceedsTop) {
      tooltip.classList.add('card-tooltip--y-bottom');
    } else {
      tooltip.classList.add('card-tooltip--y-top');
    }
  }
}

customElements.define('shop-the-look', ShopTheLook);

function setIsTouchDeviceListeners() {
  window.isTouchDevice = false; //var to indicate current input type (is touch versus no touch)
  var isTouchTimer;
  var curRootClass = ''; //var indicating current document root class ("can-touch" or "")

  function addtouchclass(e) {
    clearTimeout(isTouchTimer);
    window.isTouchDevice = true;
    if (curRootClass != 'can-touch') {
      //add "can-touch' class if it's not already present
      curRootClass = 'can-touch';
      document.documentElement.classList.add(curRootClass);
    }
    isTouchTimer = setTimeout(function () {
      window.isTouchDevice = false;
    }, 1000); //maintain "istouch" state for 500ms so removetouchclass doesn't get fired immediately following a touch event
    // console.log('isTouchDevice', window.isTouchDevice);
  }

  function removetouchclass(e) {
    if (!window.isTouchDevice && curRootClass == 'can-touch') {
      //remove 'can-touch' class if not triggered by a touch event and class is present
      window.isTouchDevice = false;
      curRootClass = '';
      document.documentElement.classList.remove('can-touch');
    }
    // console.log('isTouchDevice', window.isTouchDevice);
  }

  document.addEventListener('touchstart', addtouchclass, false); //this event only gets called when input type is touch
  document.addEventListener('mouseover', removetouchclass, false); //this event gets called when input type is everything from touch to mouse/ trackpad
}

setIsTouchDeviceListeners();

if (window.isTouchDevice) {
  document.body.classList.add('is-touch-device');
}

// https://www.browserstack.com/guide/create-browser-specific-css
function agentHas(keyword) {
  return navigator.userAgent.toLowerCase().search(keyword.toLowerCase()) > -1;
}

function isSafari() {
  return (
    (!!window.ApplePaySetupFeature || !!window.safari) &&
    agentHas('Safari') &&
    !agentHas('Chrome') &&
    !agentHas('CriOS')
  );
}

window.addEventListener('DOMContentLoaded', () => {
  if (isSafari()) {
    document.body.classList.add('is-safari');
  }
});

class CartWatcher {
  init() {
    this.emitCartChanges().then(() => {
      this.observeCartChanges();
    });
  }

  async fetchCart() {
    const response = await fetch('/cart.js');
    return response.json();
  }

  storeCart(cart) {
    localStorage.setItem('cart', JSON.stringify(cart));
  }

  storedCart() {
    return JSON.parse(localStorage.getItem('cart')) || { items: [] };
  }

  findCartChanges(oldCart, newCart) {
    const onlyInLeft = (l, r) => l.filter((li) => !r.some((ri) => li.key == ri.key));
    let result = {
      added: onlyInLeft(newCart.items, oldCart.items),
      removed: onlyInLeft(oldCart.items, newCart.items),
    };

    oldCart.items.forEach((oi) => {
      const ni = newCart.items.find((i) => i.key == oi.key && i.quantity != oi.quantity);
      if (!ni) return;
      let quantity = ni.quantity - oi.quantity;
      let item = { ...ni };
      item.quantity = Math.abs(quantity);
      quantity > 0 ? result.added.push(item) : result.removed.push(item);
    });

    return result;
  }

  async emitCartChanges() {
    const newCart = await this.fetchCart();
    const oldCart = this.storedCart();
    const changes = this.findCartChanges(oldCart, newCart);

    const event = new CustomEvent('cart_changed', { detail: changes });
    window.dispatchEvent(event);

    this.storeCart(newCart);
  }

  observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
        const isCartChangeRequest = /\/cart\//.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          this.emitCartChanges();
        }
      });
    });
    cartObserver.observe({ entryTypes: ['resource'] });
  }
}

const myCartWatcher = new CartWatcher();
myCartWatcher.init();

/**
 * Animated Details Web Component
 *
 * @param {string} data-duration - Duration of the animation in milliseconds. Defaults to 350ms.
 * @param {boolean} data-animate - Whether the component should animate. Can be dynamically toggled. Defaults to true.
 * @param {boolean} data-show-default-open - Whether the details element should be open by default. Defaults to false.
 */
class AnimatedDetails extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.content = this.querySelector('details > div');

    this.duration = this.dataset.duration || 350;
    this.showDefaultOpen = this.dataset.showDefaultOpen === 'true';

    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (this.details) {
      this.details.addEventListener('click', (e) => this.onClick(e));

      if (!this.showDefaultOpen && this.details.open) {
        this.details.open = false;
      }
    }
  }

  get shouldAnimate() {
    return this.dataset.animate !== 'false' && !this.prefersReducedMotion;
  }

  set shouldAnimate(value) {
    this.dataset.animate = value.toString();
  }

  onClick(e) {
    if (e.target.closest('summary')) {
      e.preventDefault();

      if (this.details.open) {
        this.close();
      } else {
        // console.log('Opening');
        this.open();
      }
    }
  }

  async open() {
    if (!this.shouldAnimate) {
      this.details.open = true;
      return;
    }

    this.details.style.overflow = 'hidden';
    this.details.open = true;

    const startHeight = this.summary.offsetHeight;
    const endHeight = startHeight + this.content.offsetHeight;

    if (this.animation) {
      this.animation.cancel();
    }

    const contentHeight = this.content.offsetHeight;
    const animationDuration = contentHeight > 1500 ? this.duration * 6 : this.duration;

    this.animation = this.details.animate(
      {
        height: [`${startHeight}px`, `${endHeight}px`],
      },
      {
        duration: animationDuration,
        easing: 'ease',
      }
    );

    try {
      await this.animation.finished;
      this.details.style.overflow = '';
      this.details.style.height = '';
    } catch {
      // Animation was cancelled
    }
  }

  async close() {
    if (!this.shouldAnimate) {
      this.details.open = false;
      return;
    }

    this.details.style.overflow = 'hidden';
    this.details.style.height = `${this.details.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    const contentHeight = this.content.offsetHeight;
    const animationDuration = contentHeight > 1500 ? this.duration * 6 : this.duration;

    this.animation = this.details.animate(
      {
        height: [`${this.details.offsetHeight}px`, `${this.summary.offsetHeight}px`],
      },
      {
        duration: animationDuration,
        easing: 'ease',
      }
    );

    try {
      await this.animation.finished;
      this.details.open = false;
      this.details.style.overflow = '';
      this.details.style.height = '';
    } catch {
      // Animation was cancelled
    }
  }
}

customElements.define('animated-details', AnimatedDetails);

async function _waitForSelector(selector) {
  const element = document.querySelector(selector);
  if (element) {
    return element;
  }

  return new Promise((resolve) => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const element = document.querySelector(selector);
        if (element) {
          observer.disconnect();
          resolve(element);
          return;
        }
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
}

// Reset klaviyo styles
function resetKlaviyoStyles(form, attempts = 0) {
  let count = 0;
  const formStyles = form.querySelectorAll('[style]');
  formStyles.forEach((element) => {
    element.removeAttribute('style');
    count++;
  });

  if (count === 0 && attempts < 10) {
    setTimeout(() => resetKlaviyoStyles(form, attempts + 1), 100);
    return;
  }

  form.classList.add('initialized');
}

_waitForSelector('.footer__newsletter-embed > .klaviyo-form').then((form) => {
  resetKlaviyoStyles(form);
});

class ScrollToNextSectionButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.button.addEventListener('click', () => {
      this.scrollToNextSection();
    });
  }

  scrollToNextSection() {
    const SCROLL_OFFSET = 0;

    const nextSection = this.nextElementSibling;
    if (nextSection && nextSection.tagName === 'SECTION') {
      // Had to hardcode an offset to counter the space that was being added to the top of the next section
      const y = nextSection.getBoundingClientRect().top + window.scrollY + SCROLL_OFFSET;
      window.scrollTo({ top: y, behavior: 'smooth' });
    } else {
      const closestSection = this.closest('section');
      const nextSection = closestSection.nextElementSibling;
      // console.log(nextSection);
      if (nextSection && nextSection.tagName === 'SECTION') {
        const y = nextSection.getBoundingClientRect().top + window.scrollY + SCROLL_OFFSET;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }
  }
}
customElements.define('scroll-to-next-section-button', ScrollToNextSectionButton);

// Track sections in view and add their component classes to body
document.addEventListener('DOMContentLoaded', () => {
  // Several elements can share one body class (e.g. the gallery in each A/B-tested
  // product-information section), so a class stays on while any of them is in view.
  // Toggling it per element let a hidden copy remove the class the visible one added.
  const elementsInView = new Map();
  const setInView = (bodyClass, element, isIntersecting) => {
    if (!elementsInView.has(bodyClass)) elementsInView.set(bodyClass, new Set());
    const inView = elementsInView.get(bodyClass);
    isIntersecting ? inView.add(element) : inView.delete(element);
    document.body.classList.toggle(bodyClass, inView.size > 0);
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const element = entry.target;

        // Handle sections with component classes
        if (element.tagName === 'SECTION') {
          const componentClass = Array.from(element.classList).find((c) => c.startsWith('component--'));

          if (componentClass) {
            setInView(`${componentClass}--in-view`, element, entry.isIntersecting);
          }
        }

        // Handle elements with data-track-in-view attribute
        const trackInViewValue = element.getAttribute('data-track-in-view');
        if (trackInViewValue) {
          setInView(trackInViewValue, element, entry.isIntersecting);
        }

        // Count total in-view classes on body
        const inViewClasses = Array.from(document.body.classList).filter(
          (c) => c.endsWith('--in-view') || document.querySelectorAll(`[data-track-in-view="${c}"]`).length > 0
        );
        document.body.dataset.sectionsInView = inViewClasses.length;

        document.body.classList.add('in-view-observer--init');
      });
    },
    {
      threshold: 0.05, // Trigger when at least 5% of element is visible
    }
  );

  // Initial observation of all sections and elements with data-track-in-view
  document.querySelectorAll('section, [data-track-in-view]').forEach((element) => {
    observer.observe(element);
  });

  // Watch for dynamically added elements
  const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          // Element node
          // Observe if it's a section
          if (node.tagName === 'SECTION') {
            observer.observe(node);
          }

          // Observe if it has data-track-in-view
          if (node.hasAttribute('data-track-in-view')) {
            observer.observe(node);
          }

          // Check children for data-track-in-view
          const trackableChildren = node.querySelectorAll('[data-track-in-view]');
          trackableChildren.forEach((child) => {
            observer.observe(child);
          });
        }
      });
    });
  });

  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

class TruncatedText extends HTMLElement {
  constructor() {
    super();
    this.originalContent = this.innerHTML;
    this.maxLines = parseInt(this.dataset.lines) || 3;
    this.mobileOnly = this.dataset.mobileOnly === 'true';
    this.expanded = false;

    this.EXPAND_TEXT = 'More';
    this.COLLAPSE_TEXT = 'Less';
  }

  connectedCallback() {
    this.render();
    window.addEventListener('resize', this.debounce(this.handleResize.bind(this), 250));
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize.bind(this));
  }

  // Add debounce to avoid excessive rendering on resize
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  handleResize() {
    if (this.mobileOnly) {
      this.render();
    }
  }

  render() {
    // Clear existing content
    this.innerHTML = '';

    // If mobile only and not on mobile, show full content without truncation
    if (this.mobileOnly && window.innerWidth >= 768) {
      this.innerHTML = this.originalContent;
      return;
    }

    // Create the content wrapper
    const textWrapper = document.createElement('div');
    textWrapper.className = 'truncated-text__content';
    textWrapper.innerHTML = this.originalContent;

    // Set up truncation styles
    if (!this.expanded) {
      textWrapper.style.cssText = `
      display: -webkit-box;
        -webkit-line-clamp: ${this.maxLines};
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-word;
    `;
    }

    this.appendChild(textWrapper);

    // Force a reflow to get accurate scrollHeight
    void textWrapper.offsetHeight;

    // Only add More/Less button if content is actually truncated
    const lineHeight = parseInt(window.getComputedStyle(textWrapper).lineHeight);
    const maxHeight = lineHeight * this.maxLines;
    const contentHeight = textWrapper.scrollHeight;

    if (contentHeight > maxHeight || this.expanded) {
      const toggleButton = document.createElement('button');
      toggleButton.className = 'truncated-text__toggle';
      toggleButton.style.cssText = `
        display: block;
        margin-top: 8px;
        cursor: pointer;
        background: none;
        border: none;
        padding: 0;
        color: var(--cl__high-contrast);
        font-size: 0.875rem;
        text-decoration: underline;
        font-family: var(--font-body-family);
      `;

      toggleButton.textContent = this.expanded ? this.COLLAPSE_TEXT : this.EXPAND_TEXT;

      toggleButton.addEventListener('click', () => {
        this.expanded = !this.expanded;
        this.render();
      });

      this.appendChild(toggleButton);
    }
  }
}

customElements.define('truncated-text', TruncatedText);

class AnimatedAccordionMobileSlideover extends AnimatedDetails {
  constructor() {
    super();
    this.titleContent = this.querySelector('.animated-accordion-mobile-slideover__title');
    this.image = this.querySelector('.animated-accordion-mobile-slideover__image');
    this.content = this.querySelector('.animated-accordion-mobile-slideover__content');

    this.isMobile = window.innerWidth < 768;
    this._keyboardOpen = false;
    this._lastTrigger = null;

    if (this.isMobile) {
      this.createDialog();
      this.dispatchRerenderEvent();
    }

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const newIsMobile = window.innerWidth < 768;

        if (newIsMobile !== this.isMobile) {
          this.isMobile = newIsMobile;
          if (this.isMobile) {
            this.createDialog();
          } else {
            this.createAccordion();
          }
          this.dispatchRerenderEvent();
        }
      }, 250); // 250ms debounce delay
    });
  }

  dispatchRerenderEvent() {
    const rerenderEvent = new CustomEvent('animated-accordion-rerendered', {
      bubbles: true,
      detail: { isMobile: this.isMobile },
    });
    this.dispatchEvent(rerenderEvent);
  }

  _open(animate = false) {
    if (this.isMobile) {
      // In mobile view, open the dialog using our keyboard-aware method
      this.openDialog();
    } else {
      // In desktop view, open the accordion
      const details = this.querySelector('details');
      if (details) {
        details.setAttribute('open', '');
        if (animate) {
          this.animateOpen(details);
        }
      }
    }
  }

  _isOpen() {
    if (this.isMobile) {
      // In mobile view, check if dialog is open
      const dialog = this.querySelector('dialog');
      return dialog ? dialog.open : false;
    } else {
      // In desktop view, check if details is open
      const details = this.querySelector('details');
      return details ? details.hasAttribute('open') : false;
    }
  }

  createDialog() {
    this.innerHTML = `
        <button class="animated-accordion-mobile-slideover__title" tabindex="0">
          ${this.titleContent.innerHTML}
        </button>
        ${
          (() => {
            const mediaEl = document.querySelector('.product__media-wrapper .product__featured-image-container');
            return (mediaEl && this.image) ? `<div class="animated-accordion-mobile-slideover__image">${this.image.innerHTML}
              <div class="product__featured-image-loader">
                Loading
                <span class="dot-one">.</span>
                <span class="dot-two">.</span>
                <span class="dot-three">.</span>
              </div>
            </div>` : '';
          })()
        }

        <dialog class="animated-accordion-mobile-slideover__dialog">
          <div class="animated-accordion-mobile-slideover__header">
            <button aria-label="Close" class="animated-accordion-mobile-slideover__close" tabindex=0>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon-close">
                <line x1="15.5371" y1="8.46439" x2="8.46608" y2="15.5355" stroke="currentColor"/>
                <line x1="15.5371" y1="15.5357" x2="8.466" y2="8.46461" stroke="currentColor"/>
              </svg>
            </button>
            <h2 class="animated-accordion-mobile-slideover__title-text">${
              this.titleContent.querySelector('.option-accordion__option-label').textContent
            }</h2>
          </div>
          <div class="animated-accordion-mobile-slideover__content">
            ${this.content.innerHTML}
          </div>
        </dialog>
      `;

    // Add event listeners after creating the DOM
    const titleButton = this.querySelector('.animated-accordion-mobile-slideover__title');
    const dialog = this.querySelector('dialog');
    const closeButton = this.querySelector('.animated-accordion-mobile-slideover__close');

    if (titleButton && dialog) {
      titleButton.addEventListener('click', (e) => {
        this._lastTrigger = titleButton;
        this._keyboardOpen = false;
        this.openDialog();
      });

      titleButton.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          this._lastTrigger = titleButton;
          this._keyboardOpen = true;
          this.openDialog();
        }
      });
    }

    if (closeButton && dialog) {
      closeButton.addEventListener('click', () => {
        this.closeDialog();
      });
    }
  }

  openDialog() {
    const dialog = this.querySelector('dialog');
    if (dialog) {
      dialog.classList.add('animated-accordion-mobile-slideover__dialog--no-animation');
      dialog.showModal();

      // Immediately blur any focused element to prevent Safari's default focus for mouse interactions
      if (!this._keyboardOpen && document.activeElement && document.activeElement !== document.body) {
        document.activeElement.blur();
      }

      // Only focus the close button if opened via keyboard
      if (this._keyboardOpen) {
        setTimeout(() => {
          const closeBtn = dialog.querySelector('.animated-accordion-mobile-slideover__close');
          if (closeBtn) {
            closeBtn.focus();
          }
        }, 100);
      }

      setTimeout(() => {
        dialog.classList.remove('animated-accordion-mobile-slideover__dialog--no-animation');
      }, 100);
    }
  }

  closeDialog() {
    const dialog = this.querySelector('dialog');
    if (dialog) {
      dialog.close();
      // Return focus to trigger if opened by keyboard
      if (this._keyboardOpen && this._lastTrigger) {
        setTimeout(() => {
          this._lastTrigger.focus();
        }, 0);
      } else {
        document.activeElement.blur()
      }
    }
  }

  createAccordion() {
    this.innerHTML = `
      <details>
        <summary class="animated-accordion-mobile-slideover__title">${this.titleContent.innerHTML}</summary>
        <div class="animated-accordion-mobile-slideover__content">
          ${this.content.innerHTML}
        </div>
      </details>
    `;
  }
}
customElements.define('animated-accordion-mobile-slideover', AnimatedAccordionMobileSlideover);

//   new ProductSpecsToggle();
// });

class AddToCartButton extends HTMLElement {
  constructor() {
    super();

    this.products = this.dataset.products ? this.parseProducts(this.dataset.products) : [];
    // console.log(this.products);
    this.productContainer = this.closest('[data-add-to-cart-item]');
    // Source of the event, used to track where the product was added from
    this.source = this.dataset.source || 'shopify';

    const button = this.querySelector('button');
    if (button) {
      button.addEventListener('click', this.addToCart.bind(this));
    }
  }

  // Parse the products string and convert it to the object structure
  parseProducts(productsStr) {
    return productsStr
      .split(';')
      .filter((p) => p)
      .map((product) => {
        const [variant, quantity] = product.split(':');
        return {
          id: variant,
          quantity: Number.parseInt(quantity) || 1,
        };
      });
  }

  async addToCart() {
    try {
      this.classList.add('loading');
      this.classList.add('item-added-to-cart');
      this.productContainer?.classList.add('item-added-to-cart');
      const addedProducts = await Shopify.addToCart(this.products, {
        eventData: {
          source: this.source,
        },
      });
      const { product_id } = addedProducts.items[0];
    } catch (err) {
      this.error = err.message;
    } finally {
      this.classList.remove('loading');
    }
  }

  // Method to add products programmatically
  addProduct({ variant, quantity }) {
    const existingProduct = this.products.find((p) => p.variant === variant);
    if (existingProduct) {
      existingProduct.quantity += quantity;
    } else {
      this.products.push({ variant, quantity });
    }
  }

  // Method to delete products
  deleteProduct({ variant }) {
    const index = this.products.findIndex((p) => p.variant === variant);
    if (index !== -1) {
      this.products.splice(index, 1);
    }
  }
}

customElements.define('add-to-cart-button', AddToCartButton);


if (customElements.get('feature-carousel') === undefined) {
  class FeatureCarousel extends HTMLElement {
    constructor() {
      super();
      this.sliderContainer = this.querySelector('[data-slides]'); // Assuming this container has the slides
      this.activeIndex = 0;
      this.pages = this.querySelectorAll('[data-slides] > *').length;
      this.indicatorsContainer = this.querySelector('[data-indicators]');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.autoplay = this.getAttribute('data-autoplay') || this.querySelector('[data-autoplay]') || false;
      this.intervalTime = 0;
      this.intervalId = null;
      this.autoplayInterval =
        (this.querySelector('[data-autoplay-interval]') &&
          parseInt(this.querySelector('[data-autoplay-interval]').getAttribute('data-autoplay-interval'))) ||
        parseInt(this.getAttribute('data-autoplay-interval')) ||
        8000;
      this.intervalIncrement = this.autoplayInterval / 80;
      this.infinite = this.getAttribute('data-infinite') || this.querySelector('[data-infinite]') || false;
      this.isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

      if (this.prev) this.prev.addEventListener('click', (e) => {
        this.trackCarouselClick(this.prev, e);
        this.scrollToPage(this.activeIndex - 1);
      });
      if (this.next) this.next.addEventListener('click', (e) => {
        this.trackCarouselClick(this.next, e);
        this.scrollToPage(this.activeIndex + 1);
      });
      if (this.indicatorsContainer) this.initIndicators();
      if (this.autoplay != 'false') {
        this.initAutoplay();
      }
      if (this.isTouchDevice) {
        this.addEventListener('touchstart', (e) => {
          this.stopAutoplay();
        });
        this.addEventListener('touchend', () => {
          clearInterval(this.intervalId);
          this.intervalId = setInterval(this.handleInterval.bind(this), this.intervalIncrement);
        });
      }
    }

    connectedCallback() {
      window.requestAnimationFrame(() => {
        this.resize();
        window.addEventListener('resize', this.resize.bind(this));
      });
    }

    resize() {}

    scrollToPage(index) {
      if (index >= this.pages) {
        index = 0;
      } else if (index < 0) {
        index = this.pages - 1;
      }
      this.activeIndex = index;
      if (this.indicatorsContainer) this.updateActiveIndicator();
      if (this.prev || this.next) this.updatePrevNext();
      this.querySelector('[data-active]')?.removeAttribute('data-active');
      this.querySelector(`[data-slide="${index}"]`)?.setAttribute('data-active', '');
    }

    initIndicators() {
      // console.log('initIndicators', window.isTouchDevice);
      // this.indicatorsContainer.innerHTML = ''; // Clear existing indicators
      let template = document.createElement('li');
      template.innerHTML = '<button></button>';

      for (let i = 0; i < this.pages; i++) {
        let button = this.querySelector(`.cmp-feature-full__carousel__indicator-number[data-slide="${i}"]`);
        if (!button) {
          const indicator = template.cloneNode(true);
          button = indicator.querySelector('button');
          button.innerText = i + 1;
          button.setAttribute('data-index', i);
          button.setAttribute('aria-label', `Go to slide slide ${i}`); // Accessibility
          this.indicatorsContainer.appendChild(indicator);
        }

        !window.isTouchDevice &&
          button.addEventListener('click', (e) => {
            // console.log('click handleIndicatorClick', window.isTouchDevice);
            if (e.target.tagName === 'A' && e.target.href !== '') return;
            e.stopPropagation();
            this.trackCarouselClick(button, e);
            this.handleIndicatorClick(i);
          });
        window.isTouchDevice &&
          button.addEventListener('touchend', (e) => {
            // console.log('touchend handleIndicatorClick', window.isTouchDevice);
            if (e.target.tagName === 'A' && e.target.href !== '') return;
            e.stopPropagation();
            this.trackCarouselClick(button, e);
            this.handleIndicatorClick(i);
          });

        if (this.querySelector(`[data-slide="${i}"]`) == null) {
          this.indicatorsContainer.appendChild(indicator);
        }
      }

      this.updateActiveIndicator();
    }

    handleIndicatorClick(i) {
      // console.log('handleIndicatorClick', window.isTouchDevice);
      this.stopAutoplay();
      if (this.autoplay == 'true') {
        this.intervalTime = 0;
        this.indicatorsContainer.style.setProperty('--intervalTime', 0);
      }
      this.scrollToPage(i);
      if (this.autoplay == 'true') {
        this.intervalId = setInterval(this.handleInterval.bind(this), this.intervalIncrement);
      }
    }

    trackCarouselClick(button, e) {
      if (typeof Shopify === 'undefined' || !Shopify.analytics) return;
      const sectionEl = this.closest('[data-section-name]');
      const clickData = {
        element: {
          href: button.dataset.href || '#',
          id: button.id,
          tagName: button.tagName,
          text: button.dataset.text || button.innerText,
          classList: button.classList.toString(),
          section_name: sectionEl?.dataset.sectionName || null,
          section_id: this.closest('[data-section-id]')?.dataset.sectionId || null,
          section_shopify_id: this.closest('.shopify-section')?.id || null
        },
        pageX: e.pageX,
        pageY: e.pageY
      };
      Shopify.analytics.publish('click', { clickData });
    }

    updateActiveIndicator() {
      const indicators = this.indicatorsContainer.querySelectorAll('li');

      indicators.forEach((indicator, index) => {
        if (index === this.activeIndex) {
          setTimeout(function () {
            indicator.setAttribute('data-active', '');
          }, 50);
        } else {
          indicator.removeAttribute('data-active');
        }
      });
    }

    updatePrevNext() {
      if (this.infinite == false && this.activeIndex <= 0) {
        this.activeIndex = 0;
        this.prev.setAttribute('disabled', '');
      } else {
        this.prev.removeAttribute('disabled');
      }
      if (this.infinite == false && this.activeIndex >= this.pages) {
        this.activeIndex = this.pages;
        this.next.setAttribute('disabled', '');
      } else {
        this.next.removeAttribute('disabled');
      }
    }

    initAutoplay() {
      // Uncomment below to enable pause/play on hover
      // this.querySelectorAll('.cmp-feature-full__content-wrapper').forEach((contentWrapper) => {
      //   contentWrapper.addEventListener('mouseover', () => {
      //     this.stopAutoplay();
      //   });
      //   contentWrapper.addEventListener('mouseout', () => {
      //     clearInterval(this.intervalId);
      //     this.intervalId = setInterval(this.handleInterval.bind(this), this.intervalIncrement);
      //   });
      // });
      // this.querySelectorAll('.cmp-feature-full__carousel__controls').forEach((controls) => {
      //   controls.addEventListener('mouseover', () => {
      //     this.stopAutoplay();
      //   });
      //   controls.addEventListener('mouseout', () => {
      //     clearInterval(this.intervalId);
      //     this.intervalId = setInterval(this.handleInterval.bind(this), this.intervalIncrement);
      //   });
      // });

      // Start the interval initially
      clearInterval(this.intervalId);
      this.intervalId = setInterval(this.handleInterval.bind(this), this.intervalIncrement);
    }

    handleInterval() {
      // console.log('handleInterval', this.autoplayInterval, this.intervalIncrement, this.intervalTime, this.intervalId);
      if (this.intervalTime >= this.autoplayInterval) {
        this.scrollToPage(this.activeIndex + 1);
        this.intervalTime = 0;
      } else {
        this.intervalTime += this.intervalIncrement;
        this.indicatorsContainer.style.setProperty('--intervalTime', this.intervalTime / this.autoplayInterval);
      }
    }

    stopAutoplay() {
      clearInterval(this.intervalId);
    }
  }

  customElements.define('feature-carousel', FeatureCarousel);
}

// Globo Custom JS
// Find .globo-form-input and add event listener to add .filled class to closest .globo-form-control when input is filled
function initGloboForms() {
  // console.log('DOMContentLoaded');
  let formInputs = document.querySelectorAll('.globo-form-input input');
  formInputs = Array.from(formInputs).concat(Array.from(document.querySelectorAll('.globo-form-input textarea'))); // combine with textareas

  formInputs.forEach((input) => {
    input.addEventListener('keypress', (e) => {
      const control = input.closest('.globo-form-control');
      if (e.srcElement.value + e.key != '') {
        control.classList.add('filled');
      } else {
        control.classList.remove('filled');
      }
    });
    input.addEventListener('input', (e) => {
      const control = input.closest('.globo-form-control');
      if (input.value) {
        control.classList.add('filled');
      } else {
        control.classList.remove('filled');
      }
    });
  });

  const formSelects = document.querySelectorAll('.globo-form-input select');
  formSelects.forEach((select) => {
    select.addEventListener('change', () => {
      const control = select.closest('.globo-form-control');
      if (select.value) {
        control.classList.add('filled');
      } else {
        control.classList.remove('filled');
      }
      // console.log(select.value, control);
    });
  });

  const globoForms = document.querySelectorAll('.globo-form form');
  globoForms.forEach((form) => {
    // setup hidden data fields
    
    form.addEventListener('submit', (e) => {
      if (form.closest('modal')) {
        const modal = form.closest('modal');
        trapFocus(modal, modal.querySelector('[aria-label="Close"]'));
        modal.style.height = modal.offsetHeight + 'px';
      }
    });
  });
}

// Globo clears a submitted form with form.reset(), which resets the hidden native
// <select> but not the nice-select widget drawn over it. The widget kept showing the
// old State/Country while the select was empty, so the next submit failed
// validation (MH-1400). 'reset' fires before the fields reset, hence the timeout.
document.addEventListener('reset', (e) => {
  const form = e.target;
  if (!form.closest?.('.globo-form')) return;

  setTimeout(() => {
    form.querySelectorAll('.globo-form-input select').forEach((select) => {
      if (select._gfbNiceSelect?.update) {
        select._gfbNiceSelect.update();
      } else if (select.nextElementSibling?.classList.contains('nice-select')) {
        const current = select.nextElementSibling.querySelector('.current');
        if (current) current.textContent = select.selectedOptions[0]?.textContent.trim() || '';
      }
    });

    form.querySelectorAll('.globo-form-control.filled').forEach((control) => {
      const field = control.querySelector('.globo-form-input input, .globo-form-input textarea, .globo-form-input select');
      if (field && !field.value) control.classList.remove('filled');
    });
  });
});
setTimeout(function () {
  initGloboForms();
}, 2000);

function initModalForm(modal) {
  if (modal.querySelector('.globo-form form')) {
    setTimeout(function () {
      initGloboForms();
    }, 500);
  } else {
    setTimeout(function() {
      initModalForm(modal)
    }, 500)
  }
}
if (document.querySelector('modal .globo-app-extension')) {
  document.addEventListener('modal:open', (e) => {
    initModalForm(e.detail.modal);
  });
}

function generateSrcset(imageSrc, sizes) {
  const srcset = sizes
    .map((size) => {
      const url = imageSrc.replace(
        /_(pico|icon|thumb|small|compact|medium|large|grande|original)\.(jpg|jpeg|png|gif|webp)/,
        `_${size}.$&`
      );
      return `${url} ${size}w`;
    })
    .join(', ');
  return srcset;
}

document.addEventListener('focusin', function (e) {
  // console.log('focus', document.activeElement);
});

window.isElementInViewport = function (el) {
  var rect = el.getBoundingClientRect();

  return (
    rect.bottom > 0 &&
    rect.right > 0 &&
    rect.top < (window.innerHeight || document.documentElement.clientHeight) &&
    rect.left < (window.innerWidth || document.documentElement.clientWidth)
  );
};
